import React from 'react';

export const DataHook = 'details-placeholder';

export class DetailsPlaceholder extends React.Component {
  public render(): JSX.Element {
    return <div data-hook={DataHook} />;
  }
}
